export enum InboxFilterType {
	sent = "sent",
	trash = "trash",
	starred = "starred",
	important = "important"
}
